// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G140","colBig":"styles_colBig__2f0aC","colSmall":"styles_colSmall__2zb5r"};